/**
 * Set of merge tags that we will allow in links.
 *
 * Note that this is a work-around until Handlebars supports
 * a hook to handle missing nested property values:
 * https://github.com/handlebars-lang/handlebars.js/issues/1435
 */
const validLinkMergeTags = {

	id: '89427289-2b77-422d-8470-fb17050790aa',

	author: {
		id: '89427289-2b77-422d-8470-fb17050790aa',
		email: 'test@techchange.org',
	},

	comment: {
		slug: 'a36def09-e8fd-47c0-ad6f-54b181ba5463/d656b297-c806-45b8-acec-6f7925a87a5d',
	},

	inviter: {
		email: 'test@techchange.org',
	},

	organization: {
		id: '89427289-2b77-422d-8470-fb17050790aa',
		contact_email: 'test@techchange.org',
		domain: 'course.tc',
		slug: 'test-org',
	},

	session: {
		slug: 'dev',
	},

	thread: {
		slug: 'test-thread-foHMzEUQRT4QmnVz4KDu6j',
	},

	user: {
		email: 'test@techchange.org',
		hostname: 'course.tc',
		id: '89427289-2b77-422d-8470-fb17050790aa',
	},

};

module.exports = validLinkMergeTags;
